import { useTranslations } from 'next-intl'

import ReportCard from '~/components/blocks/ReportCard/ReportCard'
import { useSettingsContext } from '~/contexts/settingsContext'

const FALLBACK_IMAGE = {
  _ref: 'image-f3a817f71dda4d12d19d36195f82f686c8ccfea5-298x200-png',
  _type: 'reference' as const,
}

const BANKSY_IMAGE = {
  _ref: 'image-f2dce9a961e5048ed9dfc8bf4d1f60831a75f01b-596x400-png',
  _type: 'reference' as const,
}

interface ArtistArticleCardProps {
  artistName: string
  artistSlug: string
}

const ArtistArticleCard = ({
  artistName,
  artistSlug,
}: ArtistArticleCardProps) => {
  const t = useTranslations('articleContainer')
  const { allArtists } = useSettingsContext()

  const artist = allArtists?.find(a => a.name === artistName)
  const isBanksy = artistName === 'Banksy'
  const leadImage = {
    asset: isBanksy ? BANKSY_IMAGE : (artist?.image ?? FALLBACK_IMAGE),
  }

  return (
    <ReportCard
      _id="artist-article-banner"
      title={t('artistArticleCardTitle', { artistName })}
      subtitle={t('artistArticleCardSubCopy', { artistName })}
      leadImage={leadImage}
      isPdfType={false}
      slug=""
      primaryCategory={{ name: '', slug: '' }}
      variant="featurePanel"
      matchGridHeight={false}
      ctaText={t('artistArticleCardCta', { artistName })}
      ctaUrl={`/artist-${artistSlug}`}
    />
  )
}

export default ArtistArticleCard
